/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Ctl_RangeInputs */

const en_exp_ctl_range = /** @type {(inputs: Exp_Ctl_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Higher = more fit. Typical: 40-70 recreational, 70-100 competitive amateur, 100+ elite. Takes 4-6 weeks of data to stabilize.`)
};

const de_exp_ctl_range = /** @type {(inputs: Exp_Ctl_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höher = fitter. Typisch: 40–70 Freizeitsportler, 70–100 ambitionierte Amateure, 100+ Elite. Braucht 4–6 Wochen Daten zur Stabilisierung.`)
};

/**
* | output |
* | --- |
* | "Higher = more fit. Typical: 40-70 recreational, 70-100 competitive amateur, 100+ elite. Takes 4-6 weeks of data to stabilize." |
*
* @param {Exp_Ctl_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_ctl_range = /** @type {((inputs?: Exp_Ctl_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Ctl_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_ctl_range(inputs)
	return de_exp_ctl_range(inputs)
});